export enum FeaturesAutomation {
  AUTOMATION_CREATE_MAX = 'automation.create.max',
  AUTOMATION_CREATE_PER_MONTH = 'automation.create.per_month',
  DOCUMENT_CREATE_PER_AUTOMATION = 'document.create.per_automation',
}

export enum FeaturesDocuments {
  DOCUMENT_DOWNLOADS_PER_MONTH = 'document.downloads.per_month',
  DOCUMENT_GENERATE_BULK_JOBS_PER_MONTH = 'document.generate.bulk.jobs.per_month',
  DOCUMENT_GENERATE_BULK_MAX_ROWS = 'document.generate.bulk.max_rows',
  DOCUMENT_GENERATE_FORM_PER_MONTH = 'document.generate.form.per_month',
}

export enum FeaturesEvaluation {
  AUTOMATION_ACTIVE = 'automation.active',
  AUTOMATION_CREATE = 'automation.create',
  DOCUMENT_CREATE = 'document.create',
  DOCUMENT_GENERATE_FORM = 'document.generate.form',
  DOCUMENT_GENERATE_BULK = 'document.generate.bulk',
  DOCUMENT_DOWNLOADS = 'document.downloads',
}
